import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/tailwind.css';
import { applyTheme } from './lib/theme';
import './lib/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 60_000 },
  },
});

// Apply persisted theme before first render (avoids flash)
const stored = JSON.parse(localStorage.getItem('sparknation-theme') || '{}');
applyTheme(stored?.state?.theme ?? 'light');

// Apply RTL direction for Arabic
const storedLang = JSON.parse(localStorage.getItem('sparknation-lang') || '{}')?.state?.lang;
if (storedLang === 'ar') document.documentElement.dir = 'rtl';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
